import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

const ScreenFlash = ({ color = "green" }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 260);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return <Flash $color={color} aria-hidden="true" />;
};

export default ScreenFlash;

const flashFade = keyframes`
  0% {
    opacity: 0.75;
  }
  100% {
    opacity: 0;
  }
`;

const Flash = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  pointer-events: none;
  animation: ${flashFade} 0.45s ease-out forwards;
  background: ${({ $color }) =>
    $color === "red"
      ? "radial-gradient(circle, transparent 45%, rgba(239, 68, 68, 0.55) 100%)"
      : "radial-gradient(circle, transparent 45%, rgba(34, 197, 94, 0.55) 100%)"};
`;
